module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container main-area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "centered"
  }, [_vm._v("Начальный уровень")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Программа курса составляет  472 ак. часов (8 месяцев)")]), _vm._v(" "), _c('span', [_vm._v("Курс состоит из трех модулей ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "enroll-btn"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-md btn-block",
    attrs: {
      "to": {
        name: 'OnlineEnrollment'
      }
    }
  }, [_vm._v("Записаться")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Продолжительность курса")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Занятия")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("Стоимость")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive": "",
      "bordered": "",
      "striped": "",
      "fields": _vm.fields,
      "items": _vm.items
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "enroll-btn"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-md btn-block",
    attrs: {
      "to": {
        name: 'OnlineEnrollment'
      }
    }
  }, [_vm._v("Записаться")])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "course-list list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("1. Обзорная экскурсия по Санкт-Петербургу")]), _vm._v(" - 230 ак. ч."), _c('br'), _vm._v("\n            (октябрь 2025 – январь 2026) \n          ")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("2. Трассовые экскурсии: Петергоф, Пушкин и Павловск")]), _vm._v(" - 152 ак.ч."), _c('br'), _vm._v("\n            (февраль 2026 – апрель 2026) \n          ")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("3. Кронштадт: трасса и обзорная по городу")]), _vm._v(" "), _c('br'), _vm._v("\n            (апрель 2026 – май 2026)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("с 02.10.24 по 21.05.26")]), _vm._v(" "), _c('li', [_vm._v("\n            472 ак. часа, в том числе \n            "), _c('ul', [_c('li', [_vm._v("7 учебных экскурсий (3 пешеходных, 4 автобусных)")]), _vm._v(" "), _c('li', [_vm._v("3 зачетные экскурсии")]), _vm._v(" "), _c('li', [_vm._v("самостоятельная работа с дополнительным методическим материалом")]), _vm._v(" "), _c('li', [_vm._v("o\tработа на экскурсионном тренажере.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("вторник, четверг с 19:00 до 22:00")]), _vm._v(" "), _c('li', [_vm._v("пешеходные, учебные и зачетные экскурсии по выходным.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("за весь курс – 69 000 руб.; при единовременной оплате скидка 5% – 65 550 руб.")]), _vm._v(" "), _c('li', [_vm._v("возможна помесячная оплата:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3417e7ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CoursesEntry.vue
// module id = 225
// module chunks = 1